import { FilterEqOperation } from '../types/serverRequests';
import { FilterType } from '../types/galleryDef';
var ListFilterModel = /** @class */ (function () {
    function ListFilterModel(title, options) {
        this.filterType = FilterType.LIST;
        this.title = title;
        this.options = options;
        this.selectedOptionIds = [];
    }
    ListFilterModel.prototype.update = function (optionId) {
        /* istanbul ignore next: todo(daniela): test this */
        if (this.selectedOptionIds.indexOf(optionId) === -1) {
            this.selectedOptionIds.push(optionId);
        }
        else {
            var index = this.selectedOptionIds.indexOf(optionId);
            this.selectedOptionIds.splice(index, 1);
        }
    };
    ListFilterModel.prototype.toDTO = function () {
        return {
            field: "options." + this.title,
            op: FilterEqOperation.IN,
            values: this.selectedOptionIds,
        };
    };
    ListFilterModel.prototype.hasSelectedOptions = function () {
        return !!this.selectedOptionIds.length;
    };
    ListFilterModel.prototype.reset = function () {
        this.selectedOptionIds = [];
    };
    return ListFilterModel;
}());
export { ListFilterModel };
//# sourceMappingURL=listFilterModel.js.map